import * as React from "react";
import { SVGProps } from "react";

const SvgNineSpades = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 251 351"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M240.7.2H10.1S.4.5.4 13.3v323.8c0 12.8 9.7 13.1 9.7 13.1h230.6s9.7-.3 9.7-13.1V13.2c0-12.8-9.7-13-9.7-13Z"
      fill="#fff"
    />
    <mask
      id="nine-spades_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={189}
      width={251}
      height={162}
    >
      <path
        d="M147.8 189c-49.1 0-98.2 0-147.3.1V337c0 12.8 9.7 13.1 9.7 13.1h230.5s9.7-.3 9.7-13.1V189H147.8Z"
        fill="url(#nine-spades_svg__a)"
      />
    </mask>
    <g mask="url(#nine-spades_svg__b)">
      <path
        d="M147.8 189c-49.1 0-98.2 0-147.3.1V337c0 12.8 9.7 13.1 9.7 13.1h230.5s9.7-.3 9.7-13.1V189H147.8Z"
        fill="url(#nine-spades_svg__c)"
      />
    </g>
    <mask
      id="nine-spades_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={251}
      height={175}
    >
      <path
        d="M.5 174.7h249.9V13.2C250.4.4 240.7.1 240.7.1H10.1S.4.4.4 13.2v161.5h.1Z"
        fill="url(#nine-spades_svg__d)"
      />
    </mask>
    <g mask="url(#nine-spades_svg__e)">
      <path
        d="M.5 174.7h249.9V13.2C250.4.4 240.7.1 240.7.1H10.1S.4.4.4 13.2v161.5h.1Z"
        fill="url(#nine-spades_svg__f)"
      />
    </g>
    <mask
      id="nine-spades_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={246}
      height={350}
    >
      <path
        d="M249.9 13.2v323.2c0 12.8-9.7 13-9.7 13H9.4s-2.1-.1-4.3-1.4c2.5 1.8 5.1 1.9 5.1 1.9h230.6s9.7-.3 9.7-13.1V13.2C250.5.4 240.8.1 240.8.1h-.5c-.1 0 9.6.3 9.6 13.1Z"
        fill="url(#nine-spades_svg__g)"
      />
    </mask>
    <g mask="url(#nine-spades_svg__h)">
      <path
        d="M249.9 13.2v323.2c0 12.8-9.7 13-9.7 13H9.4s-2.1-.1-4.3-1.4c2.5 1.8 5.1 1.9 5.1 1.9h230.6s9.7-.3 9.7-13.1V13.2C250.5.4 240.8.1 240.8.1h-.5c-.1 0 9.6.3 9.6 13.1Z"
        fill="url(#nine-spades_svg__i)"
      />
    </g>
    <mask
      id="nine-spades_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={246}
      height={351}
    >
      <path
        d="M1 336.9V13.7C1 .9 10.7.7 10.7.7h230.8s2.1.1 4.3 1.4C243.3.3 240.7.2 240.7.2H10.1S.4.5.4 13.3v323.8c0 12.8 9.7 13.1 9.7 13.1h.5c.1-.2-9.6-.5-9.6-13.3Z"
        fill="url(#nine-spades_svg__j)"
      />
    </mask>
    <g mask="url(#nine-spades_svg__k)">
      <path
        d="M1 336.9V13.7C1 .9 10.7.7 10.7.7h230.8s2.1.1 4.3 1.4C243.3.3 240.7.2 240.7.2H10.1S.4.5.4 13.3v323.8c0 12.8 9.7 13.1 9.7 13.1h.5c.1-.2-9.6-.5-9.6-13.3Z"
        fill="url(#nine-spades_svg__l)"
      />
      <mask
        id="nine-spades_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={1}
        height={303}
      >
        <path
          d="M.5 25.4v301.7c.2-.6.3-1.2.5-1.8V30.9c-.2-1.8-.4-3.6-.5-5.5Z"
          fill="url(#nine-spades_svg__m)"
        />
      </mask>
      <g mask="url(#nine-spades_svg__n)">
        <path
          d="M.5 25.4v301.7c.2-.6.3-1.2.5-1.8V30.9c-.2-1.8-.4-3.6-.5-5.5Z"
          fill="url(#nine-spades_svg__o)"
        />
      </g>
    </g>
    <path
      d="M21.3 67.3c-.5 6.5-4.2 11.1-4.2 11.1h8.4s-3.7-4.6-4.2-11.1Z"
      fill="#000"
    />
    <path
      d="M29.1 57.7c-5.2-3.6-7.8-7.4-7.9-7.5-.1.1-2.6 3.9-7.9 7.5-5.3 3.7-6.5 8.2-4.6 11.6 1.9 3.4 9.4 5.1 12.5-1.7 3 6.8 10.6 5.2 12.5 1.7 1.9-3.4.7-8-4.6-11.6ZM16 44.8v-1.1c2.1 0 3.8-.5 5.4-1.4 1.5-.9 2.7-2.3 3.6-4.1.9-1.8 1.5-4.1 1.8-7l-.2-.1c-1.2.9-2.5 1.5-3.7 1.9-1.2.4-2.5.6-3.9.6-1.7 0-3.1-.4-4.3-1.1-1.2-.7-2.1-1.8-2.6-3.1-.6-1.3-.9-2.9-.9-4.6 0-1.3.2-2.6.7-3.8.4-1.2 1.1-2.2 2-3.1.9-.9 2-1.6 3.3-2.1 1.3-.5 2.8-.8 4.6-.8 3.1 0 5.4 1.1 7.1 3.2 1.6 2.1 2.4 5.2 2.4 9.2 0 3.7-.6 6.8-1.8 9.5-1.2 2.7-2.9 4.8-5 6.3-2.2 1.5-4.7 2.4-7.5 2.6l-1-1Zm4.6-13.4c.6 0 1.1 0 1.6-.1s1-.2 1.5-.4 1-.4 1.4-.7c.5-.3.9-.6 1.2-.9.1-.1.2-.3.4-.5.1-.2.2-.4.2-.8.1-.3.1-.8.1-1.5 0-2-.2-3.7-.6-5.2-.4-1.4-1-2.5-1.9-3.2-.8-.7-1.9-1.1-3.1-1.1-1.1 0-2 .2-2.8.6-.8.4-1.4.9-1.9 1.6-.5.7-.8 1.5-1 2.4-.2.9-.3 1.9-.3 2.9 0 2.2.4 3.9 1.3 5.1 1 1.2 2.3 1.8 3.9 1.8ZM230.7 282.2c.5-6.5 4.2-11.1 4.2-11.1h-8.4s3.6 4.6 4.2 11.1Z"
      fill="#000"
    />
    <path
      d="M222.8 291.8c5.2 3.6 7.8 7.4 7.9 7.5.1-.1 2.6-3.9 7.9-7.5 5.3-3.7 6.5-8.2 4.6-11.6-1.9-3.4-9.4-5.1-12.5 1.7-3-6.8-10.6-5.2-12.5-1.7-1.9 3.4-.7 8 4.6 11.6ZM235.9 304.7v1.1c-2.1 0-3.8.5-5.4 1.4-1.5.9-2.7 2.3-3.6 4.1-.9 1.8-1.5 4.1-1.8 7l.2.1c1.2-.9 2.5-1.5 3.7-1.9 1.2-.4 2.5-.6 3.9-.6 1.7 0 3.1.4 4.3 1.1 1.2.7 2.1 1.8 2.6 3.1.6 1.3.9 2.9.9 4.6 0 1.3-.2 2.6-.7 3.8-.4 1.2-1.1 2.2-2 3.1-.9.9-2 1.6-3.3 2.1-1.3.5-2.8.8-4.6.8-3.1 0-5.4-1.1-7.1-3.2-1.6-2.1-2.4-5.2-2.4-9.2 0-3.7.6-6.8 1.8-9.5 1.2-2.7 2.9-4.8 5-6.3 2.2-1.5 4.7-2.4 7.5-2.6l1 1Zm-4.6 13.4c-.6 0-1.1 0-1.6.1s-1 .2-1.5.4-1 .4-1.4.7c-.5.3-.9.6-1.2.9-.1.1-.2.3-.4.5-.1.2-.2.4-.2.8-.1.3-.1.8-.1 1.5 0 2 .2 3.7.6 5.2.4 1.4 1 2.5 1.9 3.2.8.7 1.9 1.1 3.1 1.1 1.1 0 2-.2 2.8-.6.8-.4 1.4-.9 1.9-1.6.5-.7.8-1.5 1-2.4.2-.9.3-1.9.3-2.9 0-2.2-.4-3.9-1.3-5.1-1-1.2-2.2-1.8-3.9-1.8ZM171.1 201.2c1.1-12.9 8.4-21.9 8.4-21.9h-16.8s7.3 9 8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M155.5 220.3c10.3 7.2 15.5 14.6 15.6 14.8.1-.2 5.2-7.7 15.6-14.8 10.5-7.2 12.9-16.3 9.1-23.1-3.8-6.8-18.8-10.1-24.7 3.4-6-13.5-21-10.2-24.7-3.4-3.8 6.9-1.4 15.9 9.1 23.1ZM171.1 265.5c-1.1-12.9-8.4-21.9-8.4-21.9h16.8c-.1 0-7.4 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M186.7 284.7c-10.4 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.7 6.8 1.4 15.8-9.1 23.1ZM171.1 84.6c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1 0-7.4-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M186.7 65.5c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.8 1.4-15.9-9.1-23.1ZM171.1 148.9c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1.1-7.4-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M186.7 129.8c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.8 1.4-15.9-9.1-23.1ZM79.7 201.2c1.1-12.9 8.4-21.9 8.4-21.9H71.3s7.3 9 8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M64.1 220.3c10.3 7.2 15.5 14.6 15.6 14.8.1-.2 5.2-7.7 15.6-14.8 10.5-7.2 12.9-16.3 9.1-23.1-3.8-6.8-18.8-10.1-24.7 3.4-6-13.5-21-10.2-24.7-3.4-3.8 6.9-1.4 15.9 9.1 23.1ZM79.7 265.5c-1.1-12.9-8.4-21.9-8.4-21.9h16.8c-.1 0-7.3 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M95.3 284.7c-10.3 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.8 6.8 1.4 15.8-9.1 23.1ZM79.7 84.6c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M95.3 65.5C85 58.3 79.8 50.9 79.7 50.7c-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.9-9.1-23.1ZM79.7 148.9c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c-.1.1-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M95.3 129.8C85 122.6 79.8 115.2 79.7 115c-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.9-9.1-23.1ZM125.4 181.1C124.3 194 117 203 117 203h16.8c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M141 162c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.9 1.4-15.9-9.1-23.1Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="nine-spades_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(121.549 -119.116) scale(505.879)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(121.549 -119.116) scale(505.879)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(126.554 322.985) scale(362.495)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(126.554 322.985) scale(362.495)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.216 -.008) scale(402.495)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-10.216 -.008) scale(402.495)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(68.729 101.964) scale(342.818)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(68.729 101.964) scale(342.818)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 130.61 -.005) scale(402.606)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="nine-spades_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 130.61 -.005) scale(402.606)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgNineSpades;
